import type { FallbackIconProps } from './FallbackIcon.types';

export const FallbackIcon = (props: FallbackIconProps) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: decorative fallback icon
  <svg viewBox="0 0 100 100" width="1em" height="1em" {...props}>
    <rect strokeWidth={2} fill="none" stroke="currentcolor" x={25} y={25} width={50} height={50} />
    <line strokeWidth={2} fill="none" stroke="currentcolor" x1={25} y1={25} x2={75} y2={75} />
  </svg>
);
